/**
 * Icon Size Tokens
 * Consistent icon sizing across the application
 */

export const ICONS = {
  // Inline with text
  inline: "h-4 w-4",
  inlineSmall: "h-3 w-3",
  
  // Section headers
  sectionHeader: "h-5 w-5 text-muted-foreground",
  
  // Cards
  cardIcon: "h-4 w-4 text-muted-foreground",
  
  // Empty states
  emptyState: "h-12 w-12 mx-auto text-muted-foreground mb-4",
  
  // Status indicators
  status: "h-4 w-4",
  
  // Sidebar collapsible indicators
  sidebarChevron: "h-4 w-4",
} as const;

export type IconToken = keyof typeof ICONS;
